var ui = require('./lib-ui');

var countryCenter = {
  "NL": { lat: 52, lng: 5 },
  "HK": { lat: 22.294402, lng: 11.18572 },
  "BE": { lat: 50.665892, lng: 4.439941 },
  "DE": { lat: 50.765892, lng: 10 },
  "CN": { lat: 39.913349, lng: 116.401255 },
};

var env = {
  // cube.env.woosmapKey
  get woosmapKey() {
    if (env.env === 'prod')
      return $('[data-woosmap-key-prod]').data('woosmap-key-prod');
    else if (env.env === 'integ')
      return $('[data-woosmap-key-prod]').data('woosmap-key-integ');
    else
      return $('[data-woosmap-key-preprod]').data('woosmap-key-preprod');
  },
  get googleMapKey() {
    return $('[data-google-key]').data('google-key');
  },
  get countryMapCentegr() {
    return countryCenter[env.country] || { lat: 52, lng: 5 };
  },
  // cube.env.device
  // "desktop", "tablet", "mobile"
  get device() {
    if (ui.isMobile()) return 'mobile';
    else if (ui.isTablet()) return 'tablet';
    return 'desktop';
  },
};

// cube.env.country
// "CN", "NL", "HK", "BE" ...
env.country = window.tc_vars.env_country;

// cube.env.env
// "preprod", "prod" ...
env.env = window.tc_vars.env_work;

// cube.env.lang
// "cn", "en", "nl", "fr" ...
env.lang = window.tc_vars.env_language;

// cube.env.page
// "homepage", "pagelist", "product", "cart" ...
env.page = window.tc_vars.env_template;

module.exports = env;



// WEBPACK FOOTER //
// ./src/modules-es5/commons/lib/lib-env.js